<template>
  <div class="titlePwa" :class="{ 'titlePwa--clickable': showMore }" @click="showMore && handleClickMore()">
      <!-- 標題 -->
      <h2 class="global-title" v-html="textTitle"></h2> 
      <!-- 按鈕(前往) -->
      <div v-if="showMore" class="moreBtn">
          <span class="moreBtnText">{{ textMore }}</span><span v-if="showMoreIcon" class="icon-circle-right" style="margin-left: 4px;"></span>
      </div>
  </div>
</template>
<script>
export default {
  name: "PwaTitle",
  props: {

    textTitle: {   
      type: String,
      default: ""
    },
    showMore: {
      type: Boolean,
      default: true
    },
    showMoreIcon: {
      type: Boolean,
      default: true
    },
    textMore: {       // 父層傳進來的說明文字
      type: String,
      default: ""
    }
  },
  methods: {
    handleClickMore() {
      //alert("子層內建事件");
      this.$emit("clickMore"); // 再通知父層
    }
  }  
};
</script>
<style scoped>
.titlePwa--clickable {
    cursor: pointer;
}
</style>
